<div id="layout-wrapper">
  <!-- Top Bar -->
  <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-topbar>
  <!-- Mobile Sidebar Backdrop (not focusable - visual dismiss layer) -->
   
  <div class="sidebar-backdrop" (click)="closeMobileMenu()" aria-hidden="true"></div>
  <!-- Side Bar -->
  <app-sidebar (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-sidebar>
  <div class="main-content">
    <div class="page-content">
      <div class="container-fluid">
        <!-- Main Content -->
        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- <app-footer></app-footer> -->
  </div>

  <!-- Concierge Chat Widget (floating) -->
  <app-concierge-chat></app-concierge-chat>
</div>
